import SchoolsAdapter from './base';

export default class Group extends SchoolsAdapter {
  modelNamePlural = 'groups';
}
